import { FC, useState, useEffect } from 'react';
import { Button, ButtonProps, Tooltip } from '@robocorp/components';
import { IconCheck2, IconCopy } from '@robocorp/icons/iconic';
import { useTranslation } from 'react-i18next';

type Props = {
  value: string;
  plain?: boolean;
  multiLine?: boolean;
  text?: string;
} & Pick<ButtonProps, 'disabled' | 'variant' | 'round' | 'flex'>;

const CopyToClipboard: FC<Props> = ({ value, plain, text, multiLine, ...rest }) => {
  const [clicked, setClicked] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setClicked(false);
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, [clicked, setClicked]);

  const copyToClipboard = () => {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.innerHTML = multiLine ? value : value.replace(/[\n\r\t]/g, '');
    dummy.select();
    dummy.focus();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    setClicked(true);
  };

  const actionText = typeof text === 'string' ? text : t('copyToClipboard');

  return (
    <>
      {plain ? (
        <Tooltip text={actionText} placement="top">
          <Button
            icon={clicked ? IconCheck2 : IconCopy}
            onClick={copyToClipboard}
            aria-label="copy to clipboard"
            {...rest}
          />
        </Tooltip>
      ) : (
        <Button {...rest} icon={clicked ? IconCheck2 : IconCopy} onClick={copyToClipboard}>
          {actionText}
        </Button>
      )}
    </>
  );
};

export default CopyToClipboard;
